import { Routes, RouterModule, PreloadAllModules} from '@angular/router';
import { HomeComponent } from './home/index';
import { LoginComponent } from './login/index';
import { RegisterComponent } from './register/index';
import { ReservationComponent } from './reservation/index'
import { ProfilesComponent } from './profiles/index'
import { CreditesComponent } from './credites/index'
import { RefProgramComponent } from './ref-program/index'
import { UserfeedbackComponent } from './userfeedback/index'
import { AuthGuard } from './_guards/index';
import { WizardComponent } from './wizard/index';
import { ViewreservationComponent } from './viewreservation/index';
import { BranchNameComponent } from './branchname/index';
import { AddressComponent } from './address/index';
import { BussinesshoursComponent } from './bussinesshours/index';
import { WifidetailsComponent } from './wifidetails/index';
import { ContactdetailsComponent } from './contactdetail/index';
import { BranchscancodeComponent } from './branchscancode/index';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { config } from '../config/acl';
import { JsonUpdateComponent } from './jsonupdate/jsonupdate.component';
import { DiagnosisComponent } from './diagnosis/diagnosis.component';
import { ProfilesV1Component } from './profiles-v1/profiles-v1.component';

const appRoutes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'reservation', component: ReservationComponent, canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: 'profiles', component: ProfilesComponent, canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: 'profiles-v1', component: ProfilesV1Component },
  { path: 'wizard', component: WizardComponent },
  { path: 'referral', component: RefProgramComponent, canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: 'Userfeedback/:id', component: UserfeedbackComponent, canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: 'viewreservation/:id', component: ViewreservationComponent, canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: 'branchname', component: BranchNameComponent, canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: 'address', component: AddressComponent, canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: 'bussinesshours', component: BussinesshoursComponent, canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: 'wifidetails', component: WifidetailsComponent, canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: 'contactdetail', component: ContactdetailsComponent, canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: 'branchscancode', component: BranchscancodeComponent, canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: 'jsonupdate', component: JsonUpdateComponent, canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: 'payment', loadChildren: './payment/payment.module#PaymentModule', canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: 'diagnosis', component: DiagnosisComponent },
  { path: '', loadChildren: './Loyalty/loyalty.module#LoyaltyModule', canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: '', loadChildren: './FeedBack/feedback.module#FeedbackModule', canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: '', loadChildren: './master/master.module#MasterModule', canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: '', loadChildren: './POS/pos.module#PosModule', canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: '', loadChildren: './Marketing/marketing.module#MarketingModule', canActivate: [AuthGuard] },
  { path: '', loadChildren: './Analytics/analytics.module#AnalyticModule', canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: '', loadChildren: './Table_Reservation/table.module#TableReservationModule', canActivate: [AuthGuard] },
  { path: '', loadChildren: './MeetingRoom/meeting.module#MeetingRoomModule', canActivate: [AuthGuard] },
  { path: '', loadChildren: './OnlineOrdering/onlineorder.module#OnlineOrderModule', canActivate: [AuthGuard] },
  { path: '', loadChildren: './BOT/bot.module#BotModule', canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: '', loadChildren: './Factura/factura.module#FacturaModule', canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: '', loadChildren: './Restaurant_Details/restaurant.module#RestaurantModule', canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: '', loadChildren: './Events/event.module#EventModule', canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: '', loadChildren: './ACL/acl.module#ACLModule', canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: '', loadChildren: './Monitoring/monitoring.module#MonitoringModule', canActivate: [AuthGuard, NgxPermissionsGuard] },
  { path: '', loadChildren: './kiosk/kiosk.module#KioskModule', canActivate: [AuthGuard, NgxPermissionsGuard] },


  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

export const routing = RouterModule.forRoot(appRoutes, { preloadingStrategy: PreloadAllModules });



// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/app.routing.ts